/**
 * Instagram — extrator PURO (sem React, sem react-tweet): reconhece `/p/<código>/`,
 * `/reel/<código>/`, `/reels/<código>/` e `/tv/<código>/` em instagram.com / instagr.am.
 *
 * Devolve tipo + código para o embed oficial (`instagram.com/<tipo>/<código>/embed/`) — o mesmo
 * iframe que o `embed.js` do Instagram injeta, só que SEM o script de terceiros (zero JS, SSR).
 * Fica fora do `Component.tsx` de propósito: quem só precisa reconhecer a URL (o conversor de
 * RichText, os testes) não arrasta o `react-tweet` e o CSS dele.
 */
export type InstagramEmbedRef = { kind: 'p' | 'reel' | 'tv'; code: string }

export function extractInstagramEmbed(url: string): InstagramEmbedRef | null {
  try {
    const u = new URL(url.trim())
    const host = u.hostname.replace(/^www\./, '')
    if (host !== 'instagram.com' && host !== 'instagr.am') return null
    const m = u.pathname.match(/^\/(p|reel|reels|tv)\/([A-Za-z0-9_-]+)\/?/)
    if (!m) return null
    const kind = m[1] === 'reels' ? 'reel' : (m[1] as 'p' | 'reel' | 'tv')
    return { kind, code: m[2]! }
  } catch {
    return null
  }
}

/** URL do iframe oficial (com legenda). */
export function instagramEmbedSrc(ref: InstagramEmbedRef): string {
  return `https://www.instagram.com/${ref.kind}/${ref.code}/embed/captioned/`
}
